<template>
  <div id="adverteren" class="page">
      <ContentHeader header-title="Adverteren bij RTVP!"/>
      <h3>Snel en doeltreffend je doelgroep bereiken? Kies voor radio en/of tv reclame.</h3>
      <p>Met een professionele commercial die regelmatig wordt herhaald komt je boodschap binnen no-time binnen bij de mensen die het moeten horen. 
      Radio en tv-reclame kunnen heel snel inspelen op de ontwikkelingen en op de wensen van de adverteerder. 
      Heel snel inspelen doe je met een heel snel medium en een partner die weet hoe belangrijk het is om snel iets aan de luisteraars en kijkers over te brengen. 
      Laat u verrassen door onze aantrekkelijke tarieven.</p>
      <p>Neem contact op met onze salesafdeling door te mailen met <span class="orange">sales@rtvparkstad.nl</span> of bel tijdens kantooruren met <b>06 29548396</b>.</p>
      <img src="@/assets/radioplayer/cover-maurice-schreijen.png" >
      <h3>Maurice Schreijen – Salesmanager</h3>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";

export default {
  name: "Adverteren",
  components: {
    ContentHeader
  },
}
</script>

<style lang="scss">
#adverteren {
  margin: auto;
  max-width: 768px;

 h3 {
    font-family: "Lato";
    color: #ffae32;
    font-weight: bold;
    margin-bottom: 15px;  
    }

  p {
    font-family: "Lato";
    font-size: 14px;
    margin-bottom: 16px;

    .orange {
      color: #FF5000;
    }
  }
  img {
    height: auto;
    width: 100%;
  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #adverteren {
      margin: 16px 16px;
    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #adverteren {
      margin: 16px 16px;
    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #adverteren {
        margin: 16px 16px;
    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #adverteren {
      margin-top: 160px;
      margin-bottom: 100px;
    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #adverteren {
      margin-top: 160px;
      margin-bottom: 100px;
    }
}
</style>